// src/data/planning/targetCatalog.js

/**
 * REHBER360 - RESMÎ HEDEF KATALOĞU
 *
 * Kaynak:
 * MEB Özel Eğitim ve Rehberlik Hizmetleri Genel Müdürlüğü
 * EK-2 Hedef Listesi
 *
 * ÖNEMLİ:
 * - Yerel ve özel hedefler yalnızca bu katalogdan seçilir.
 * - Kullanıcı serbest hedef yazamaz.
 * - officialLabel kaynak belgedeki ifadeyi temsil eder.
 * - Genel hedef bu dosyadan seçilmez; eğitim yılı
 *   konfigürasyonundan sistem tarafından getirilir.
 */

export const TARGET_CATALOG_VERSION = "MEB-EK2-V1";

export const TARGET_CATALOG = [

  // =========================================================
  // SOSYAL DUYGUSAL GELİŞİM ALANI
  // =========================================================

  {
    id: "aile_ici_iletisim",
    officialLabel: "Aile İçi İletişim",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "akran_zorbaligi",
    officialLabel: "Akran Zorbalığı",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "atilganlik",
    officialLabel: "Atılganlık",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "bagimlilikla_mucadele",
    officialLabel: "Bağımlılıkla Mücadele",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "bilincli_teknoloji_kullanimi",
    officialLabel: "Bilinçli Teknoloji Kullanımı",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "bireysel_farkliliklara_saygi",
    officialLabel: "Bireysel Farklılıklara Saygı",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "cinsel_egitim",
    officialLabel: "Cinsel Eğitim",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "catisma_cozme_becerileri",
    officialLabel: "Çatışma Çözme Becerileri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "degisen_yasam_kosullarina_uyum",
    officialLabel: "Değişen yaşam koşullarına uyum",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "duygu_duzenleme",
    officialLabel: "Duygu Düzenleme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "duygu_farkindaligi",
    officialLabel: "Duygu Farkındalığı",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "elestiriye_tolerans_gosterme",
    officialLabel: "Eleştiriye Tolerans Gösterme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "etik_davranis",
    officialLabel: "Etik davranış",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "gelisim_donemi_ozellikleri",
    officialLabel: "Gelişim Dönemi Özellikleri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "girisimcilik",
    officialLabel: "Girişimcilik",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "hak_ve_sorumluluklarini_bilme",
    officialLabel: "Hak ve Sorumluluklarını Bilme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "hayat_boyu_ogrenme",
    officialLabel: "Hayat Boyu Öğrenme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "ihmal_istismardan_korunma",
    officialLabel: "İhmal İstismardan Korunma",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "iletisim_becerileri",
    officialLabel: "İletişim Becerileri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "is_birligi_gelistirme",
    officialLabel: "İş birliği Geliştirme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "karar_verme_becerisi",
    officialLabel: "Karar Verme Becerisi",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "mukemmelliyetcilik",
    officialLabel: "Mükemmelliyetçilik",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "otokontrol",
    officialLabel: "Otokontrol",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "ofke_yonetimi",
    officialLabel: "Öfke Yönetimi",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "ozfarkindaligi_gelistirme",
    officialLabel: "Özfarkındalığı Geliştirme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "ozguven_gelistirme",
    officialLabel: "Özgüven Geliştirme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "ozsaygi_gelistirme",
    officialLabel: "Özsaygı Geliştirme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "problem_cozme_becerileri",
    officialLabel: "Problem Çözme Becerileri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "psikolojik_saglamlik",
    officialLabel: "Psikolojik Sağlamlık",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "saglikli_yasam",
    officialLabel: "Sağlıklı Yaşam",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "sinir_koyma",
    officialLabel: "Sınır Koyma",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "sosyal_beceriler",
    officialLabel: "Sosyal Beceriler",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "stresle_bas_etme_becerileri",
    officialLabel: "Stresle Baş Etme Becerileri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "siddeti_onleme",
    officialLabel: "Şiddeti Önleme",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "toplumsal_uyum_becerileri",
    officialLabel: "Toplumsal Uyum Becerileri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "yaraticilik",
    officialLabel: "Yaratıcılık",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "yardim_arama",
    officialLabel: "Yardım arama",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "yasam_becerileri",
    officialLabel: "Yaşam Becerileri",
    developmentArea: "social_emotional",
    active: true
  },

  {
    id: "yetersizligi_kabul",
    officialLabel: "Yetersizliği Kabul",
    developmentArea: "social_emotional",
    active: true
  },


  // =========================================================
  // AKADEMİK GELİŞİM ALANI
  // =========================================================

  {
    id: "akademik_ozyeterlik",
    officialLabel: "Akademik Özyeterlik",
    developmentArea: "academic",
    active: true
  },

  {
    id: "devamsizligi_onleme",
    officialLabel: "Devamsızlığı Önleme",
    developmentArea: "academic",
    active: true
  },

  {
    id: "dikkat_gelistirme_calismalari",
    officialLabel: "Dikkat Geliştirme Çalışmaları",
    developmentArea: "academic",
    active: true
  },

  {
    id: "e_kpss",
    officialLabel: "E-KPSS",
    developmentArea: "academic",
    active: true
  },

  {
    id: "hedef_belirleme",
    officialLabel: "Hedef Belirleme",
    developmentArea: "academic",
    active: true
  },

  {
    id: "motivasyon",
    officialLabel: "Motivasyon",
    developmentArea: "academic",
    active: true
  },

  {
    id: "okul_basarisini_artirma",
    officialLabel: "Okul Başarısını Artırma",
    developmentArea: "academic",
    active: true
  },

  {
    id: "okul_kurallari",
    officialLabel: "Okul Kuralları",
    developmentArea: "academic",
    active: true
  },

  {
    id: "okul_olgunlugu",
    officialLabel: "Okul Olgunluğu",
    developmentArea: "academic",
    active: true
  },

  {
    id: "okul_ve_cevre_sosyokulturel_imkanlar",
    officialLabel: "Okul ve Çevresindeki Sosyokültürel İmkanlar",
    developmentArea: "academic",
    active: true
  },

  {
    id: "okula_ve_cevreye_uyum",
    officialLabel: "Okula ve Çevreye Uyum",
    developmentArea: "academic",
    active: true
  },

  {
    id: "okulda_secilecek_alan_dallar",
    officialLabel: "Okulda Seçilecek Alan/Dallar",
    developmentArea: "academic",
    active: true
  },

  {
    id: "oz_disiplin_gelistirme",
    officialLabel: "Öz Disiplin Geliştirme",
    developmentArea: "academic",
    active: true
  },

  {
    id: "ozduzenlemeli_ogrenme",
    officialLabel: "Özdüzenlemeli Öğrenme",
    developmentArea: "academic",
    active: true
  },

  {
    id: "rpd_hizmetlerinin_tanitilmasi",
    officialLabel: "Rehberlik ve Psikolojik Danışma Hizmetlerinin Tanıtılması",
    developmentArea: "academic",
    active: true
  },

  {
    id: "sinav_kaygisi",
    officialLabel: "Sınav Kaygısı",
    developmentArea: "academic",
    active: true
  },

  {
    id: "ust_ogrenim_kurumlarinin_tanitilmasi",
    officialLabel: "Üst Öğrenim Kurumlarının Tanıtılması",
    developmentArea: "academic",
    active: true
  },

  {
    id: "ust_ogrenime_gecis_sinavlari",
    officialLabel: "Üst Öğrenime Geçiş Sınavları",
    developmentArea: "academic",
    active: true
  },

  {
    id: "verimli_ders_calisma_teknikleri",
    officialLabel: "Verimli Ders Çalışma Teknikleri",
    developmentArea: "academic",
    active: true
  },

  {
    id: "zaman_yonetimi",
    officialLabel: "Zaman Yönetimi",
    developmentArea: "academic",
    active: true
  },


  // =========================================================
  // KARİYER GELİŞİM ALANI
  // =========================================================

  {
    id: "is_ve_meslek_etigi",
    officialLabel: "İş ve Meslek Etiği",
    developmentArea: "career",
    active: true
  },

  {
    id: "is_yasamina_yonelik_beceriler",
    officialLabel: "İş Yaşamına Yönelik Beceriler",
    developmentArea: "career",
    active: true
  },

  {
    id: "kalfalik_ustalik_sistemleri",
    officialLabel: "Kalfalık ve Ustalık Sistemleri Hakkında Bilgilendirme",
    developmentArea: "career",
    active: true
  },

  {
    id: "kariyer_gelisimi",
    officialLabel: "Kariyer Gelişimi",
    developmentArea: "career",
    active: true
  },

  {
    id: "kariyer_planlama",
    officialLabel: "Kariyer Planlama",
    developmentArea: "career",
    active: true
  },

  {
    id: "meslek_ilgi_deger_yetenek_kisilik_iliskisi",
    officialLabel:
      "Meslekle İlgi, Değer, Yetenek ve Kişilik Özellikleri İlişkisi",
    developmentArea: "career",
    active: true
  },

  {
    id: "meslek_sahibi_olmanin_onemi",
    officialLabel: "Meslek Sahibi Olmanın Önemi",
    developmentArea: "career",
    active: true
  },

  {
    id: "meslek_secerken_dikkat_edilecek_hususlar",
    officialLabel: "Meslek Seçerken Dikkat Edilmesi Gereken Hususlar",
    developmentArea: "career",
    active: true
  },

  {
    id: "meslek_tanitimi",
    officialLabel: "Meslek Tanıtımı",
    developmentArea: "career",
    active: true
  },

  {
    id: "mesleki_benlik",
    officialLabel: "Mesleki Benlik",
    developmentArea: "career",
    active: true
  },

  {
    id: "mesleki_hedef_belirleme",
    officialLabel: "Mesleki Hedef Belirleme",
    developmentArea: "career",
    active: true
  }

];


// =========================================================
// GELİŞİM ALANI BİLGİLERİ
// =========================================================

export const TARGET_DEVELOPMENT_AREAS = {
  social_emotional: {
    id: "social_emotional",
    label: "Sosyal Duygusal Gelişim Alanı",
    order: 1
  },

  academic: {
    id: "academic",
    label: "Akademik Gelişim Alanı",
    order: 2
  },

  career: {
    id: "career",
    label: "Kariyer Gelişim Alanı",
    order: 3
  }
};


// =========================================================
// YARDIMCI FONKSİYONLAR
// =========================================================

export const getTargetById = (targetId) => {
  return (
    TARGET_CATALOG.find(
      target => target.id === targetId && target.active
    ) || null
  );
};


export const isOfficialTarget = (targetId) => {
  return TARGET_CATALOG.some(
    target => target.id === targetId && target.active
  );
};


export const getTargetsByDevelopmentArea = (developmentArea) => {
  return TARGET_CATALOG.filter(
    target =>
      target.active &&
      target.developmentArea === developmentArea
  );
};


export const getActiveTargets = () => {
  return TARGET_CATALOG.filter(target => target.active);
};


export const getGroupedTargets = () => {
  return Object.keys(TARGET_DEVELOPMENT_AREAS)
    .map(areaId => ({
      ...TARGET_DEVELOPMENT_AREAS[areaId],
      targets: getTargetsByDevelopmentArea(areaId)
    }))
    .sort((a, b) => a.order - b.order);
};